import {
  Icon,
  ICONS,
  Button,
  Typography,
  TYPOGRAPHY_SIZE,
  PLATFORM_THEME_COLORS,
} from '@thinknet-gmbh/platform-common-ui';
import {
  HeaderTitle,
  ButtonWrapper,
  HeaderContainer,
  ElementContainer,
  PopoverInfoWrapper,
} from 'src/pages/gantt/gantt-calendar/gantt-view/components/gantt-popover/gantt-popover.styles';
import { useDeleteRecordEntry } from 'src/hooks/gantts-records/delete-gantt-record.hook';

import { IAbsenceGanttInfo } from './absence-gantt-info.interface';

const AbsenceGanttInfo = ({
  absence,
  actionAllowed,
  t,
  openEditModal,
  onClose,
}: IAbsenceGanttInfo) => {
  const {
    _id,
    groupId,
    fullDay,
    name,
    startDateString,
    endDateString,
    plannedEntryHours,
    details,
  } = absence;
  const { deleteRecordEntry } = useDeleteRecordEntry({ onSuccess: onClose });
  const [startDate, endDate] = [
    startDateString.replaceAll('-', '.'),
    endDateString.replaceAll('-', '.'),
  ];
  const isOneDay = startDate === endDate;

  return (
    <PopoverInfoWrapper>
      <HeaderContainer>
        <HeaderTitle>
          <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
            {t('gantt:labels.absenceDetails')}
          </Typography>

          <Icon
            icon={ICONS.editAlt}
            size={22}
            color={
              actionAllowed
                ? PLATFORM_THEME_COLORS.primary.blue
                : PLATFORM_THEME_COLORS.grayVariations.medium
            }
            onClick={() => actionAllowed && openEditModal()}
          />
        </HeaderTitle>

        <Icon
          icon={ICONS.xCloseIcon}
          rightMargin={false}
          size={22}
          color={PLATFORM_THEME_COLORS.grayVariations.murky}
          onClick={onClose}
        />
      </HeaderContainer>
      <ElementContainer>
        <Typography weight="bold">{t('gantt:labels.absenceType')}:</Typography>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{name}</Typography>
      </ElementContainer>
      <ElementContainer>
        <Typography weight="bold">{t('gantt:labels.date')}:</Typography>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
          {isOneDay ? startDate : `${startDate}-${endDate}`}
        </Typography>
      </ElementContainer>
      {isOneDay && !fullDay && (
        <ElementContainer>
          <Typography weight="bold">{t('gantt:labels.hours')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {plannedEntryHours} hr
          </Typography>
        </ElementContainer>
      )}
      {fullDay && (
        <ElementContainer>
          <Typography weight="bold">
            <Icon icon={ICONS.timeFive} rightMargin={false} />
          </Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {t('employee:labels.fullDay')}
          </Typography>
        </ElementContainer>
      )}

      {details && (
        <ElementContainer>
          <Typography weight="bold">{t('gantt:labels.details')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{details}</Typography>
        </ElementContainer>
      )}
      <ButtonWrapper color={PLATFORM_THEME_COLORS.tone.red}>
        <Button
          type="text"
          icon={ICONS.trash}
          iconColor={PLATFORM_THEME_COLORS.tone.red}
          disabled={!actionAllowed}
          onClick={() => actionAllowed && deleteRecordEntry(groupId, _id)}
        >
          {t('common:buttons.remove')}
        </Button>
      </ButtonWrapper>
    </PopoverInfoWrapper>
  );
};

export default AbsenceGanttInfo;
